import { Injectable } from '@angular/core';
import { driver, type Config, type DriveStep } from 'driver.js';

@Injectable({ providedIn: 'root' })
export class TrunkingSummaryTourService {
  start(): void {
    const steps: DriveStep[] = [
      {
        element: '#tour-trunk-header',
        popover: {
          title: 'Trunking Summary',
          description:
            'This screen retrieves trunking metrics for one or more NS domains: channel counts, telephone numbers (TNs), 911 lines, and fax lines.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-trunk-domain-selector',
        popover: {
          title: 'Domain Selector',
          description:
            'Select one or more domains and click <strong>Get trunking summaries</strong>. Only domains that have trunking data are listed here.',
          side: 'bottom',
          align: 'start',
        },
      },
      {
        element: '#tour-trunk-results',
        popover: {
          title: 'Per-Domain Cards',
          description:
            'Each selected domain gets a card showing its trunking metrics: channels, TNs, 911 lines, billable counts, and fax lines. Use the <strong>Download</strong> button to export all results as CSV.',
          side: 'top',
          align: 'start',
        },
      },
    ];

    const config: Config = {
      showProgress: true,
      nextBtnText: 'Next',
      prevBtnText: 'Back',
      doneBtnText: 'Done',
      progressText: '{{current}} of {{total}}',
      steps,
    };

    driver(config).drive();
  }
}
